import React from 'react';
import '../styles/compliance.css';

const Compliance = () => {
  return (
    <section className="compliance-section">
      <h2 className="compliance-title"><span className="highlight">Legal Regulation</span> and Compliance of <span className="highlight">Mahadev Book</span></h2>
      <p className="compliance-subtitle">
        At <strong>Mahadev Book</strong>, we focus on providing users with a safe, secure, and legal betting experience.
        Every undertaking is done legally and ethically as the platform is operated in a highly regulated fashion.
      </p>

      <div className="compliance-grid">
        <div className="compliance-box">
          <h3>Licensed and Regulated</h3>
          <p>
            Mahadev Book is legal and meets all the norms applicable to such an online betting company,
            thus making sure that every interaction you have will be safe and will take place in adherence
            to the law of both the jurisdiction and the international community.
          </p>
        </div>

        <div className="compliance-box">
          <h3>Responsible Gaming Practices</h3>
          <p>
            We always inscribe and practice responsible gaming and would like it to be as such all over the world.
            Most majors Mahadev Book activities provide some reasonable means for users to control participation in
            wagering activities, which includes both setting withdrawal limits and voluntary withdrawal.
          </p>
        </div>

        <div className="compliance-box">
          <h3>Data Security and Privacy</h3>
          <p>
            Your privacy is our crown. To this end, all user information including personal and financial information
            is fully off limits since the company has adopted the latest encryption measures.
          </p>
        </div>

        <div className="compliance-box">
          <h3>Fair Play and Transparency</h3>
          <p>
            There was no collusion on the part of the prospective or even of the performing subcontractor. This also
            helped in instilling trust as all betting on Mahadev Book is done in an open and fair manner. All casino
            game outcomes are fair because we utilize licensed RNGs which have been certified.
          </p>
        </div>
      </div>

      <p className="compliance-footer">
        When you opt for Mahadev Book, you not only undergo an exhilarating betting process but also experience a sense of
        security, legal obligation, and responsibility. Download Mahadev Book Mobile App today and experience the thrilling
        world of sports wagering and casino life without any worries!
      </p>
    </section>
  );
};

export default Compliance;
